'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'dumbbell';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f44b';
var svgPathData = 'M464 64c29.8 0 54.8 20.4 61.9 48l10.1 0c39.8 0 72 32.2 72 72l0 48 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 48c0 39.8-32.2 72-72 72l-10.1 0c-7.1 27.6-32.1 48-61.9 48-35.3 0-64-28.7-64-64l0-104-160 0 0 104c0 35.3-28.7 64-64 64-29.8 0-54.8-20.4-61.9-48L104 400c-39.8 0-72-32.2-72-72l0-48-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-48c0-39.8 32.2-72 72-72l10.1 0c7.1-27.6 32.1-48 61.9-48 35.3 0 64 28.7 64 64l0 104 160 0 0-104c0-35.3 28.7-64 64-64zM176 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-8.8-7.2-16-16-16zm288 0c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-8.8-7.2-16-16-16zM104 160c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24l8 0 0-192-8 0zM528 352l8 0c13.3 0 24-10.7 24-24l0-144c0-13.3-10.7-24-24-24l-8 0 0 192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDumbbell = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;